import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule } from '@angular/router'
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { SharedModule } from '../../shared/shared.module'
import { AuditLogExportComponent } from './audit-log-export/audit-log-export.component'
import { AuditLogsComponent } from './audit-logs.component'
import { auditLogsRoutes } from './audit-logs.routing'

@NgModule({
  declarations: [AuditLogsComponent, AuditLogExportComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(auditLogsRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
    RxReactiveFormsModule,
  ],
})
export class AuditLogsModule {}
